import { authAPI } from 'config/api-routlink';
import request from 'shared/service/request';

export const login = async ({ username, password }) => {
  const rdata = await request.post(authAPI.LOGIN, {
    username,
    password,
  });

  return {
    setchangepassword: rdata.data.setchangepassword,
    data: rdata.data.data,
  };
};

export const forgetpassw = async ({ username }) => {
  const rdata = await request.post(authAPI.FORGOT_PASSW, {
    username,
  });

  return {
    data: rdata.data.data,
  };
};

export const confirmpassw = async ({
  username,
  type,
  verificationcode,
  newpassword,
}) => {
  const rdata = await request.post(authAPI.CONFIRM_PASSW, {
    username,
    type,
    verificationcode,
    newpassword,
  });

  return {
    data: rdata.data.data,
  };
};

export const changepassw = async ({ username, password, newpassword }) => {
  const rdata = await request.post(authAPI.CHANGE_PASSW, {
    username,
    password,
    newpassword,
  });

  return {
    data: rdata.data.data,
  };
};
